export default __webpack_public_path__ + "static/media/Parking - Blue.69fe9bd0.svg";